module.exports = __webpack_public_path__ + "static/scale-model-of-sheldon-museum-of-art-in-lincoln-nebraska-cc949ca0b76c935dcc63ad18c2b4bcfe.png";